import script from "./BalDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./BalDropdown.vue?vue&type=style&index=0&id=374e3806&scoped=true&lang=css"
script.__scopeId = "data-v-374e3806"

export default script